package com.pincer.core.rules

import com.pincer.core.model.tree.Candidate

class FixedRule(val fixed: Float): Rule() {
    override fun score(candidate: Candidate): Float = fixed
}